import AuthorList from './author-list';

export default AuthorList;
